module.exports = __webpack_public_path__ + "img/traits_banner_animation.85396287.gif";